import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledBrochuresWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 27px;
  padding: 10px 30px 55px;
  flex-wrap: wrap;

  @media screen and (min-width: ${Breakpoints.b560}px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 0 46px;
  }
`;
